import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth.service';

@Component({
  selector: 'aaos-faculty-page',
  templateUrl: './faculty-page.component.html',
  styleUrls: ['./faculty-page.component.scss']
})
export class FacultyPageComponent implements OnInit {

  constructor(private dialog: MatDialog, private authService: AuthService) { }

  editPrivileges = false;
  ngOnInit(): void {
    this.editPrivileges = this.authService.changeAuthorized(); }

  getModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: null,
    } as MatDialogConfig;
  }

}
